import React from "react";
import StudentOnboardingEmoji from "./Emoji/main";
import StudentOnboardingFinal from "./Final/main";
import StudentOnboardingGeneral from "./General/main";
import StudentOnboardingJob from "./Job/main";
import StudentOnboardingLanguage from "./Language/main";
import StudentOnboardingStudy from "./Study/main";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { ROUTES } from "../../../db/models/const";
import StudentOnboardingCompetence from "./Competence/main";

const StudentOnboarding = () => {
    const history = useHistory();

	return (
		<Switch>
			<Route path={ROUTES.STUDENT_ONBOARDING_EMOJI} exact>
				<StudentOnboardingEmoji handleGoNext={() => history.push(ROUTES.STUDENT_ONBOARDING_GENERAL)} />
			</Route>

			{/* this component dropped out from the procedure of onboarding */}
			{/*<Route path={ROUTES.STUDENT_ONBOARDING_WELCOME} exact>*/}
			{/*	<StudentOnboardingWelcome handleGoNext={() => history.push(ROUTES.STUDENT_ONBOARDING_GENERAL)} />*/}
			{/*</Route>*/}

			<Route path={ROUTES.STUDENT_ONBOARDING_GENERAL} exact>
				<StudentOnboardingGeneral handleGoNext={() => history.push(ROUTES.STUDENT_ONBOARDING_STUDY)} />
			</Route>
			{/* <StudentOnboardingInterest step={step} handleGoNext={handleGoNext} handleGoBack={handleGoBack} />} */}
			<Route path={ROUTES.STUDENT_ONBOARDING_STUDY} exact>
				<StudentOnboardingStudy handleGoNext={() => history.push(ROUTES.STUDENT_ONBOARDING_COMPETENCE)} />
			</Route>
			<Route path={ROUTES.STUDENT_ONBOARDING_COMPETENCE} exact>
				<StudentOnboardingCompetence handleGoNext={() => history.push(ROUTES.STUDENT_ONBOARDING_LANGUAGE)} />
			</Route>
			<Route path={ROUTES.STUDENT_ONBOARDING_LANGUAGE} exact>
				<StudentOnboardingLanguage handleGoNext={() => history.push(ROUTES.STUDENT_ONBOARDING_JOB)} />
			</Route>
			<Route path={ROUTES.STUDENT_ONBOARDING_JOB} exact>
				<StudentOnboardingJob handleGoNext={() => history.push(ROUTES.STUDENT_ONBOARDING_FINAL)} />
			</Route>
			<Route path={ROUTES.STUDENT_ONBOARDING_FINAL} exact>
				<StudentOnboardingFinal handleGoNext={() => history.push(ROUTES.PROFILE)} />
			</Route>

            <Redirect to={ROUTES.STUDENT_ONBOARDING_EMOJI}/>
		</Switch>
	);
};

export default StudentOnboarding;
